export const nav = 1;

export default {
  ["role-permissions"]: {
    nav,
    icon: "user-secret",
    url: "/auth/role-permissions",
    title: "Role Permissions",
    templateProvider: $stateParams => `<role-permissions-editor />`
  },
  ["permission-list-manager"]: {
    nav,
    icon: "shield",
    url: "/auth/permission-list-manager",
    title: "Permission Lists",
    templateProvider: $stateParams => `<permission-list-manager />`
  },
  ["menu-manager"]: {
    nav,
    icon: "bars",
    url: "/auth/manage-menu",
    title: "Manage Menu",
    templateProvider: $stateParams => `<page-left-nav-admin />`
  }
};
